module.exports = __webpack_public_path__ + "static/img/SmartPlatform5.6e98b83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SmartPlatform5.png
// module id = ZHqx
// module chunks = 13